<div class="page-container">
    
    
    
    <div class="typography">
        <div class="image"><img src="assets/img/FindMI-Main-Logo-sidebar.png" /></div>
      <h1>404</h1>
      <h4>Page not found</h4>
    </div>
    <div class="actions">
  
    </div>
  </div>
  